import { isNil } from "lodash";
import { memo } from "react";
import { useSelector } from "react-redux";

import { LOCATIONS_PLAN_TYPE } from "../../../consts/planTypes";

import {
  getMatrixProfileType,
  locationConfigSelector,
} from "../../../reducers/matrixProfile/selectors";
import { RouteMarker } from "./RouteMarker";
import { LocationMarker } from "./LocationMarker";

export const LocationLayer = memo(() => {
  const planType = useSelector(getMatrixProfileType);
  const locationConfig = useSelector(locationConfigSelector);

  if (planType !== LOCATIONS_PLAN_TYPE || !locationConfig) return null;
  return (
    <>
      {locationConfig
        .filter(
          ({ longitude, latitude }) => !isNil(longitude) && !isNil(latitude)
        )
        .map((location, index) => {
          return (
            <LocationMarker
              key={`locationMarker_${index}`}
              location={location}
            />
          );
        })}
      {locationConfig
        .filter(
          ({ longitude, latitude }) => !isNil(longitude) && !isNil(latitude)
        )
        .map((location, index) => {
          return (
            <RouteMarker key={`routeMarker_${index}`} location={location} />
          );
        })}
    </>
  );
});
